export default __webpack_public_path__ + "static/media/green-map-dot.4e011c49.svg";